export default __webpack_public_path__ + "static/media/ding2_mild_V2.e50d3a02.ogg";